// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"0627b737","202":"b1390f4c","402":"dabf6568","486":"e2c91a8d","550":"8e8e2b63","640":"2366b5d2","799":"54cd5125"}[chunkId] + ".chunk.js";
};